export enum UtcOffsets {
  'GMT-12' = -720,
  'GMT-11' = -660,
  'GMT-10' = -600,
  'GMT-9' = -540,
  'GMT-8' = -480,
  'GMT-7' = -420,
  'GMT-6' = -360,
  'GMT-5' = -300,
  'GMT-4' = -240,
  'GMT-3' = -180,
  'GMT-2' = -120,
  'GMT-1' = -60,
  'GMT' = 0,
  'GMT+1' = 60,
  'GMT+2' = 120,
  'GMT+3' = 180,
  'GMT+4' = 240,
  'GMT+5' = 300,
  'GMT+6' = 360,
  'GMT+7' = 420,
  'GMT+8' = 480,
  'GMT+9' = 540,
  'GMT+10' = 600,
  'GMT+11' = 660,
}
